module.exports = __webpack_public_path__ + "static/media/icon9.3e44e07c.svg";